import React from "react";

import styled from "@emotion/styled";
import { Link } from "gatsby";
import { useState } from "react";
import { useEffect } from "react";
import Tolo from "../svgs/tolo.svg";
import { Toggle } from "./toggle";
import { mediaChange, showHideOverflowY } from "../utils";

const StyledNav = styled.nav`
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  padding: var(--small) 0;
  text-transform: uppercase;
  font-size: var(--x-small);
  letter-spacing: 3px;
  border-bottom: 1px solid transparent;
  transition: all 0.2s;

  @media (max-width: 820px) {
    padding: var(--xs) 0;
  }

  &.scrolled-out {
    background: rgba(0, 0, 0, 0.6);
    border-color: var(--divider);
    backdrop-filter: saturate(0.5) blur(5px);
  }

  a {
    color: var(--sub);
  }

  .row {
    display: flex;
    justify-content: space-between;
  }

  .logo-link {
    display: flex;
    align-items: center;
    font-size: 2.5rem;
    font-weight: 400;

    img {
      height: 30px;
      margin-right: var(--xsm);

      @media (max-width: 1060px) {
        height: 20px;
        margin-right: var(--xs);
      }
    }
  }

  .links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--xl);

    @media (max-width: 820px) {
      gap: var(--md);
    }
  }

  .mobile-container {
    background: var(--bg);
  }

  .mobile-links {
    width: 100%;
    margin: var(--2xl) 0;
    display: flex;
    flex-direction: column;
    gap: var(--md);
    font-size: var(--small);
    text-align: center;

    & > * {
      width: 100%;
    }
  }

  .desktop {
    @media (max-width: 690px) {
      display: none;
    }
  }

  .mobile {
    display: none;
    @media (max-width: 690px) {
      display: block;
    }
  }
`;

export const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolledOut, setScrolledOut] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY) {
        setScrolledOut(true);
      } else {
        setScrolledOut(false);
      }
    });
  });

  useEffect(() => {
    showHideOverflowY(isOpen);
    mediaChange("(min-width: 901px)", () => {
      setIsOpen(false);
      showHideOverflowY(false);
    });
  }, [isOpen]);

  return (
    <StyledNav className={scrolledOut ? "scrolled-out" : ""}>
      <div className="row">
        <Link to="/" className="logo-link">
          <img src={Tolo} alt="" />
          Tolo Construction
        </Link>
        <div className="links desktop">
          <Link to="/residential">Residential</Link>
          <Link to="/commercial">Commercial</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/about">About</Link>
          <Link to="/contact" className="btn-sm">
            Contact
          </Link>
        </div>
        <div className="mobile">
          <Toggle onClick={handleClick} isOpen={isOpen} />
        </div>
      </div>
      {isOpen ? (
        <div className="mobile mobile-container">
          <div className="row">
            <div className="mobile-links">
              <Link to="/residential">Residential</Link>
              <Link to="/commercial">Commercial</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/about">About</Link>
              <div>
                <Link to="/contact" className="btn-cta btn-sm">
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </StyledNav>
  );
};
